import { DialogueData } from "@/components/Dialog"
import { create } from "zustand"

export interface DialogState {
    dialog: DialogueData[]
    callbackDialogCompleted: () => void
    startDialog: (
        dialog: DialogueData[],
        callbackDialogCompleted?: () => void
    ) => void
    endDialog: () => void
}

export const useDialogStore = create<DialogState>((set, get) => ({
    dialog: [],
    callbackDialogCompleted: () => {},
    startDialog: (dialog, callbackDialogCompleted) => {
        set({ dialog, callbackDialogCompleted })
    },
    endDialog: () => {
        const { callbackDialogCompleted } = get()
        set({ dialog: [], callbackDialogCompleted: () => {} })
        setTimeout(() => {
            callbackDialogCompleted?.()
        }, 0)
    },
}))
